import { handleHttpResponse } from "../../utils/http_response_utils";

/** POST multipart file; response includes task_id for celery polling (see services/celery). */
export const uploadCollectionData = async (data) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/upload-collection-data", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: data,
  });
  return handleHttpResponse(response);
};

/** POST a Google Sheet link; response includes task_id for celery polling (see services/celery). */
export const uploadCollectionDataLink = async ({ platformType, url }) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/upload-collection-data-link", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ platform_type: platformType, url }),
  });
  return handleHttpResponse(response);
};
